export const COPIED_DELAY_MS = 1000;
